var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowBadge)?_c('div',[_c('badge',{attrs:{"type":_vm.getBadgeType()}},[_vm._v(" "+_vm._s(_vm.statusLabel)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }